import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import PostControls from 'flarum/forum/utils/PostControls';
import HandleLookupModal from './HandleLookupModal';
import { handleOf } from './handle';
import { lookupTarget } from './whoIsThis';

/**
 * "Who is this?" in a post's moderation controls -- Task 6.7.
 *
 * Drawn only when `lookupTarget()` says so: the server has said this viewer
 * may resolve handles (`canResolveHandles`, ForumResourceFields), the post
 * carries a real handle, and it is not the viewer's own. **Otherwise the item
 * is not added at all** -- hidden, not disabled (§9, 6.7). Flarum draws the
 * moderation section only when it has items, so for everyone else the menu is
 * exactly what it was.
 *
 * The viewer's own handle comes from `myHandle`, which the discussion carries
 * for its Issue (5.6); a post from another Issue's discussion is compared with
 * that discussion's `myHandle`, never with a handle from somewhere else.
 *
 * `PostControls` is a plain utility, not a lazy chunk (checked against
 * `public/assets/js/core/forum/` at 6.7), so the static import is safe (4.2).
 */
export default function lookupControl() {
  extend(PostControls, 'moderationControls', function (items, post) {
    const discussion = post?.discussion?.();
    const viewerHandle = discussion?.myHandle?.() ?? null;
    const handle = lookupTarget(handleOf(post), typeof viewerHandle === 'string' ? viewerHandle : null, app.forum.attribute('canResolveHandles') === true);
    if (!handle) return;
    items.add('ideasynqWhoIsThis', m(Button, {
      icon: "fas fa-user-secret",
      onclick: () => app.modal.show(HandleLookupModal, {
        handle,
        postId: post.id()
      })
    }, app.translator.trans('ideasynq-handles.forum.lookup.control')));
  });
}